import { createContext, useContext } from "react";

import type { FilterPanelViewModel } from "./types-filter-panel";

export const FilterPanelContext = createContext<FilterPanelViewModel | null>(null);

export function useFilterPanelContext(): FilterPanelViewModel {
  const context = useContext(FilterPanelContext);
  if (!context) throw new Error("FilterPanel.* deve ser usado dentro de FilterPanel.Root");
  return context;
}
